import { minHeight } from "@mui/system";

export const LandingStyles = {
  root: {
    display: 'flex',
    minHeight: '111.11vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(45deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
      zIndex: 1,
    },
  },
  leftSection: {
    flex: { xs: 0, md: 1 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
    minWidth: 0,
    overflow: 'hidden',
    position: 'relative',
    zIndex: 2,
  },
  image: {
    width: { xs: '100%', md: '100%' },
    height: { xs: '300px', md: '111.11vh' },
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: { xs: '20px', md: '0' },
    boxShadow: { xs: '0 20px 40px rgba(0, 0, 0, 0.3)', md: 'none' },
  },
  rightSection: {
    flex: { xs: 1, md: 1 },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    color: 'rgb(13, 39, 84)',
    padding: { xs: '2rem 1.5rem', md: '0 3rem' },
    minWidth: 0,
    minHeight: { xs: 'auto', md: '111.11vh' },
    position: 'relative',
    zIndex: 2,
    borderRadius: { xs: '20px 20px 0 0', md: '0' },
    marginTop: { xs: '-20px', md: '0' },
  },
  welcome: {
    letterSpacing: { xs: 3, md: 6 },
    fontSize: { xs: 16, md: 20 },
    color: 'rgba(13, 39, 84, 0.7)',
    textAlign: 'center',
    fontWeight: 300,
    fontFamily: '"BD Sans", sans-serif',
    textTransform: 'uppercase',
    marginBottom: '1rem',
  },
  logoTitleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: { xs: '16px', md: '24px' },
    margin: { xs: '1rem 0', md: '2rem 0 1rem 0' },
    flexDirection: { xs: 'column', sm: 'row' },
  },
  logo: {
    width: { xs: 60, md: 100 },
    height: { xs: 60, md: 100 },
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1) rotate(5deg)',
    },
  },
  title: {
    fontFamily: '"Higuen Serif", serif',
    fontWeight: 600,
    fontSize: { xs: 48, sm: 64, md: 80 },
    background: 'linear-gradient(45deg, #667eea, #764ba2)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textAlign: 'center',
    lineHeight: 1.1,
    margin: 0,
    padding: 0,
    letterSpacing: { xs: 1, md: 2 },
    animation: 'moveDown 1.5s ease-out forwards',
    transform: 'translateY(-20px)',
    opacity: 0,
    '@keyframes moveDown': {
      '0%': {
        transform: 'translateY(-20px)',
        opacity: 0,
      },
      '100%': {
        transform: 'translateY(0)',
        opacity: 1,
      },
    },
  },
  subtitle: {
    fontSize: { xs: 20, md: 28 },
    color: 'rgba(13, 39, 84, 0.8)',
    textAlign: 'center',
    letterSpacing: { xs: 3, md: 6 },
    fontFamily: '"Cormorant Garamond", serif',
    marginTop: 0,
    marginBottom: '2rem',
  },
  button: {
    background: 'linear-gradient(45deg, #667eea, #764ba2)',
    color: '#fff',
    borderRadius: 12,
    padding: { xs: '12px 32px', md: '14px 48px' },
    fontSize: { xs: 16, md: 20 },
    fontWeight: 600,
    border: 'none',
    transition: 'all 0.3s ease',
    marginTop: '0.5rem',
    fontFamily: '"BD Sans", sans-serif',
    letterSpacing: { xs: 1, md: 2 },
    textTransform: 'uppercase',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
    position: 'relative',
    overflow: 'hidden',
    '&:hover': {
      background: 'linear-gradient(45deg, #764ba2, #667eea)',
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
  },
  sectionTwo: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    minHeight: { xs: 'auto', md: '111.11vh' },
    background: 'linear-gradient(135deg, #f8f9ff 0%, #e3f8ff 100%)',
    padding: { xs: '3rem 1rem', md: 0 },
    position: 'relative',
    overflow: 'hidden',
  },
  sectionTwoLeft: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: { xs: 'center', md: 'flex-start' },
    paddingLeft: { xs: '1rem', md: '3rem' },
    paddingRight: { xs: '1rem', md: '2rem' },
    color: 'rgb(13, 39, 84)',
    textAlign: { xs: 'center', md: 'left' },
  },
  sectionTwoTitle: {
    fontSize: { xs: 28, sm: 36, md: 40 },
    fontWeight: 600,
    lineHeight: 1.15,
    fontFamily: '"Glacial Indifference", sans-serif',
    marginBottom: '1rem',
    marginTop: 0,
    color: 'rgb(13, 39, 84)',
    textAlign: { xs: 'center', md: 'left' },
    letterSpacing: 0,
  },
  sectionTwoBold: {
    fontWeight: 700,
    fontSize: { xs: 18, md: 20 },
    marginBottom: '0.5rem',
    color: 'rgb(13, 39, 84)',
    fontFamily: '"Glacial Indifference", sans-serif',
    textAlign: { xs: 'center', md: 'left' },
  },
  sectionTwoText: {
    fontSize: { xs: 16, md: 20 },
    color: 'rgba(13, 39, 84, 0.8)',
    fontWeight: 400,
    marginTop: 0,
    marginBottom: '2rem',
    fontFamily: '"Glacial Indifference", sans-serif',
    textAlign: { xs: 'center', md: 'left' },
    lineHeight: 1.5,
  },
  sectionTwoButton: {
    background: 'linear-gradient(45deg, #ffa726, #fb8c00)',
    color: '#fff',
    fontWeight: 600,
    fontSize: { xs: 16, md: 20 },
    borderRadius: 12,
    padding: { xs: '14px 28px', md: '16px 36px' },
    boxShadow: '0 4px 15px rgba(255, 167, 38, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'linear-gradient(45deg, #fb8c00, #ffa726)',
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(255, 167, 38, 0.4)',
    },
    textTransform: 'none',
    minWidth: { xs: 280, md: 320 },
    marginBottom: '1rem',
  },
  sectionTwoSubtext: {
    fontSize: 16,
    color: '#231f1e',
    opacity: 0.7,
    marginTop: 2,
    fontFamily: 'Poppins, sans-serif',
    textAlign: 'center',
  },
  sectionTwoRight: {
    flex: { xs: 1, md: 1 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: { xs: '2rem 1rem', md: 0 },
  },
  sectionTwoLaptop: {
    width: { xs: '100%', md: '100%' },
    maxWidth: { xs: '400px', md: 'none' },
    borderRadius: { xs: '20px', md: '0' },
    boxShadow: { xs: '0 20px 40px rgba(0, 0, 0, 0.2)', md: 'none' },
  },
  sectionThree: {
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: { xs: 'auto', md: '111.11vh' },
    padding: { xs: '3rem 1rem', md: '4rem 2rem' },
  },
  sectionThreeTitle: {
    fontSize: { xs: 24, sm: 28, md: 30 },
    fontWeight: 600,
    textAlign: 'center',
    color: 'rgb(13, 39, 84)',
    fontFamily: '"Glacial Indifference", sans-serif',
    marginBottom: '3rem',
    marginTop: 0,
    letterSpacing: 1,
    lineHeight: 1.3,
  },
  painPointsRow: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    gap: { xs: '2rem', md: '1rem' },
    maxWidth: '1200px',
  },
  painPoint: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: { xs: '1 1 100%', md: '0 1 300px' },
    minWidth: { xs: '280px', md: '300px' },
    maxWidth: { xs: '400px', md: '340px' },
    background: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '20px',
    padding: '2rem',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 15px 40px rgba(0, 0, 0, 0.15)',
    },
  },
  painPointIcon: {
    fontSize: 90,
    color: 'rgb(13, 39, 84)',
    marginBottom: '1rem',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  painPointText: {
    fontSize: { xs: 16, md: 18 },
    color: 'rgb(13, 39, 84)',
    textAlign: 'center',
    fontWeight: 400,
    lineHeight: 1.4,
    fontFamily: '"Glacial Indifference", sans-serif',
  },
  sectionThreeQuote: {
    fontSize: { xs: 18, md: 20 },
    fontStyle: 'italic',
    fontWeight: 600,
    color: 'rgb(13, 39, 84)',
    textAlign: 'center',
    fontFamily: '"Glacial Indifference", sans-serif',
    marginTop: '3rem',
    marginBottom: 0,
    letterSpacing: 0.5,
    lineHeight: 1.4,
    maxWidth: '800px',
    padding: '1.5rem',
    background: 'rgba(255, 255, 255, 0.6)',
    borderRadius: '15px',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
  },
  sectionFour: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    background: 'linear-gradient(135deg, #e3f8ff 0%, #f8f9ff 100%)',
    padding: { xs: '3rem 1rem', md: '4rem 2rem' },
    position: 'relative',
    minHeight: { xs: 'auto', md: '111.11vh' },
  },
  sectionFourBubble: {
    position: 'relative',
    background: `url('https://res.cloudinary.com/dh0eho4vx/image/upload/v1752986376/talking_shape_tikzbu.png') no-repeat center/contain`,
    width: { xs: '300px', md: '650px' },
    height: { xs: '250px', md: '500px' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: { xs: 0, md: '60px' },
    marginLeft: { xs: 0, md: '40px' },
    marginBottom: { xs: '2rem', md: 0 },
    zIndex: 2,
  },
  sectionFourBubbleTitle: {
    fontSize: 22,
    fontWeight: 500,
    color: '#231f1e',
    marginBottom: '18px',
    marginLeft: '18px',
    marginTop: '18px',
    fontFamily: 'Poppins, sans-serif',
  },
  organGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(2, 1fr)',
    gap: '24px',
    width: '90%',
    margin: '0 auto',
    marginTop: '10px',
  },
  sectionFourRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: { xs: 'center', md: 'flex-start' },
    justifyContent: 'center',
    zIndex: 2,
    textAlign: { xs: 'center', md: 'left' },
  },
  sectionFourTitle: {
    fontSize: { xs: 24, sm: 28, md: 30 },
    fontWeight: 600,
    color: 'rgb(13, 39, 84)',
    fontFamily: '"Glacial Indifference", sans-serif',
    marginBottom: '2rem',
    lineHeight: 1.1,
  },
  featureList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    fontSize: { xs: 16, md: 18 },
    color: 'rgb(13, 39, 84)',
    fontFamily: '"Glacial Indifference", sans-serif',
    fontWeight: 400,
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    fontSize: { xs: 16, md: 18 },
    color: 'rgb(13, 39, 84)',
    fontFamily: '"Glacial Indifference", sans-serif',
    fontWeight: 400,
    gap: '1rem',
    padding: '0.5rem',
    borderRadius: '10px',
    transition: 'all 0.3s ease',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.5)',
      transform: 'translateX(5px)',
    },
  },
  checkIcon: {
    color: '#69be35',
    fontSize: { xs: 24, md: 28 },
    marginRight: '0.5rem',
    flexShrink: 0,
  },
  founderLetterSection: {
    width: '100%',
    background: 'linear-gradient(135deg, #e3f8ff 0%, #f8f9ff 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: { xs: '3rem 1rem', md: '4rem 2rem' },
  },
  founderLetterContainer: {
    background: 'rgba(255, 255, 255, 0.95)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    width: { xs: '100%', md: '90%' },
    maxWidth: '800px',
    padding: { xs: '2rem 1.5rem', md: '3rem 2rem' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '20px',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
  },
  founderLetterHeader: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'center',
    gap: '1rem',
    marginBottom: '2rem',
    justifyContent: 'center',
  },
  founderLetterEnvelope: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: { xs: 0, sm: '0.5rem' },
  },
  founderLetterTitle: {
    fontSize: { xs: 24, md: 32 },
    fontWeight: 600,
    color: 'rgb(13, 39, 84)',
    fontFamily: '"Glacial Indifference", sans-serif',
    letterSpacing: 1,
    textAlign: 'center',
  },
  founderLetterBody: {
    width: '100%',
    marginTop: '0.5rem',
  },
  founderLetterText: {
    fontSize: { xs: 16, md: 18 },
    color: 'rgb(13, 39, 84)',
    fontFamily: '"Glacial Indifference", sans-serif',
    lineHeight: 1.7,
    whiteSpace: 'pre-line',
    textAlign: 'left',
    marginTop: 0,
  },
  testimonialSection: {
    background: 'linear-gradient(135deg, #e3f8ff 0%, #f8f9ff 100%)',
    minHeight: { xs: 'auto', md: '70vh' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: { xs: '3rem 1rem', md: '4rem 2rem' },
  },
  testimonialTitle: {
    fontSize: { xs: 28, sm: 36, md: 40 },
    fontWeight: 600,
    color: 'rgb(13, 39, 84)',
    fontFamily: '"Glacial Indifference", sans-serif',
    textAlign: 'center',
    marginBottom: '3rem',
    marginTop: 0,
  },
  testimonialCards: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: '1.5rem', md: '2rem' },
    justifyContent: 'center',
    width: '100%',
    maxWidth: '1200px',
    marginBottom: 0,
  },
  testimonialCard: {
    background: 'rgba(255, 255, 255, 0.95)',
    border: '1px solid rgba(102, 126, 234, 0.2)',
    borderRadius: '20px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    padding: { xs: '1.5rem', md: '2rem' },
    flex: 1,
    minWidth: { xs: '280px', md: '300px' },
    maxWidth: { xs: '400px', md: '370px' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'space-between',
    justifyContent: 'space-between',
    backdropFilter: 'blur(10px)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 15px 40px rgba(0, 0, 0, 0.15)',
    },
  },
  testimonialStarsAndTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '1.5rem',
  },
  testimonialStars: {
    color: '#ffd600',
    fontSize: { xs: 32, md: 40 },
    marginBottom: '1rem',
  },
  testimonialText: {
    fontSize: { xs: 16, md: 18 },
    color: 'rgb(13, 39, 84)',
    fontWeight: 400,
    lineHeight: 1.5,
    textAlign: 'center',
  },
  testimonialNameContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  testimonialName: {
    fontWeight: 700,
    fontSize: { xs: 18, md: 20 },
    color: 'rgb(13, 39, 84)',
  },
  testimonialClass: {
    fontSize: { xs: 14, md: 16 },
    color: 'rgba(13, 39, 84, 0.7)',
    marginTop: '0.25rem',
  },
  finalSection: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    minHeight: { xs: 'auto', md: '60vh' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: { xs: '3rem 1rem', md: '4rem 2rem' },
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(45deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
      zIndex: 1,
    },
  },
  finalHeadline: {
    fontSize: { xs: 28, sm: 36, md: 40 },
    fontWeight: 700,
    color: '#fff',
    textAlign: 'center',
    fontFamily: '"Glacial Indifference", sans-serif',
    marginBottom: '2rem',
    position: 'relative',
    zIndex: 2,
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
  },
  finalButton: {
    background: 'linear-gradient(45deg, #ffa726, #fb8c00)',
    color: '#fff',
    fontWeight: 600,
    fontSize: { xs: 16, md: 20 },
    borderRadius: 12,
    padding: { xs: '16px 32px', md: '18px 36px' },
    margin: { xs: '1rem 0', md: '1.5rem 0' },
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 4px 15px rgba(255, 167, 38, 0.4)',
    transition: 'all 0.3s ease',
    textTransform: 'none',
    position: 'relative',
    zIndex: 2,
    '&:hover': {
      background: 'linear-gradient(45deg, #fb8c00, #ffa726)',
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(255, 167, 38, 0.5)',
    },
  },
  finalCheckRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 2,
    marginBottom: 3
  },
  finalCheck: {
    color: '#f7931a',
    fontSize: 48,
    marginRight: 16,
  },
  finalAccessText: {
    fontSize: 30,
    color: '#231f1e',
    fontWeight: 400,
  },
  finalSubtext: {
    fontSize: 20,
    color: '#231f1e',
    textAlign: 'center',
    marginBottom: 10,
  },
  finalBold: {
    fontWeight: 700,
  },
  footer: {
    background: 'linear-gradient(135deg, #231f1e 0%, #181412 100%)',
    color: '#e0d7ce',
    padding: { xs: '1.5rem 1rem', md: '2rem 0' },
    textAlign: 'center',
    width: '100%',
  },
  footerText: {
    fontSize: { xs: 12, md: 14 },
    color: '#e0d7ce',
    fontFamily: '"BD Sans", sans-serif',
    opacity: 0.8,
    margin: 0,
  },
}; 